import {defineStore} from "pinia";
import GroupAPI from "@/api/GroupAPI";

export const useSubGroupStore = defineStore('sub-group', {
  state: () => ({
    data: [],
  }),
  actions: {
    find(id) {
      return this.data.find(data => parseInt(data.id) === parseInt(id)) || null;
    },
    index(payload) {
      const { params } = payload;
      params.prependURL = 'subs/';

      return new GroupAPI().index(params)
      .then((response) => {
        this.data = response.data;
        return response;
      });
    },
    store(payload) {
      return new GroupAPI().store(payload)
        .then((response) => {
          return response;
        });
    },
  },
  persist: true,
});
